import { render, staticRenderFns } from "./MobileWallpaperDetail.vue?vue&type=template&id=26dbcbe2&scoped=true&"
import script from "./MobileWallpaperDetail.vue?vue&type=script&lang=js&"
export * from "./MobileWallpaperDetail.vue?vue&type=script&lang=js&"
import style0 from "./MobileWallpaperDetail.vue?vue&type=style&index=0&id=26dbcbe2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dbcbe2",
  null
  
)

export default component.exports